import { BREAKPOINTS } from '@aveneo/frontmoon-viewport-watcher/lib/components/constants';

export const MODULE_NAME = 'catalog';

const prefix = `${MODULE_NAME}/`;

export const ACTION_TYPES = {
    CATALOG_FETCHED: `${prefix}CATALOG_FETCHED`,
    CITY_CATALOG_FETCHED: `${prefix}CITY_CATALOG_FETCHED`
};

export const CITIES_NUMBER_ON_VIEWPORT = {
    [BREAKPOINTS.DESKTOP_XL.name]: 23,
    [BREAKPOINTS.DESKTOP.name]: 23,
    [BREAKPOINTS.TABLET_HORIZONTAL.name]: 15,
    [BREAKPOINTS.TABLET.name]: 11,
    [BREAKPOINTS.MOBILE.name]: 11,
    [BREAKPOINTS.MOBILE_XS.name]: 11
};
